// import Cookies from 'js-cookie'

const TokenKey = 'authToken'
const RefreshToken = "authRefreshToken";
const AppInfo = "AppInfo";

export function getToken() {
  // return localStorage.getItem(TokenKey)
  return sessionStorage.getItem(TokenKey)
}

export function setToken(token) {
  // localStorage.setItem(TokenKey, token)
  sessionStorage.setItem(TokenKey, token)
}

export function removeToken() {
  // localStorage.removeItem(TokenKey)
  sessionStorage.removeItem(TokenKey)
}


export function getRefreshToken() {
  return sessionStorage.getItem(RefreshToken);
}

export function setRefreshToken(token) {
  return sessionStorage.setItem(RefreshToken, token);
}

export function removeRefreshToken() {
  return sessionStorage.removeItem(RefreshToken);
}

export function getAppInfo() {
  // return localStorage.getItem(TokenKey)
  return sessionStorage.getItem(AppInfo)
}

export function setAppInfo(info) {
  // localStorage.setItem(TokenKey, token)
  sessionStorage.setItem(AppInfo, info)
}

export function removeAppInfo() {
  // localStorage.removeItem(TokenKey)
  sessionStorage.removeItem(AppInfo)
}


